import {createAction, handleActions} from 'redux-actions';

const SET_FOOTER = 'code/SET_FOOTER';
export const setFooter = createAction(SET_FOOTER);

// 초기 state를 정해줍니다
let initialState = {
	noticeMessage : '',
	isNoticePopup : false,

	isPopup1: false,
	type: '',
	part: '',
}

export default handleActions({
	[SET_FOOTER]: (state, action) => {
		action.payload = action.payload ? action.payload : {}
		return {
			...state,
			// 관리자 코드
			isNoticePopup: action.payload.isNoticePopup,
			noticeMessage: action.payload.noticeMessage ? action.payload.noticeMessage : state.noticeMessage,
			// 프론트 저널
			isPopup1: action.payload.isPopup1,
			type: action.payload.type ? action.payload.type : state.type,
			part: action.payload.part ? action.payload.part : state.part,
		}
	},
}, initialState)
